export default __webpack_public_path__ + "static/media/logo_streetparking.2bf83577.svg";